<div class="prechat-wrapper">
  <div class="stars-bg"></div>
  <div class="stars-fg"></div>

  <!-- Sticky Navbar -->
  <nav class="custom-navbar card-glass d-flex justify-content-between align-items-center px-3 py-2">
    <button title="back" class="btn btn-outline-light" (click)="router.navigate(['/home'])">
      <i class="bi bi-arrow-left"></i>
    </button>
    <h4 class="text-white m-0 neon-title">
      {{ activeTab === 'conversations' ? 'Conversations' : 'Liked Users' }}
    </h4>
    <div *ngIf="activeTab === 'conversations'" class="d-flex align-items-center gap-2">
      <input title="check" type="checkbox" [(ngModel)]="selectAll" (change)="toggleSelectAll()" />
      <button title="delete" class="btn btn-outline-light" (click)="deleteSelected()">
        <i class="bi bi-trash3-fill"></i>
      </button>
    </div>
    <div *ngIf="activeTab === 'liked'" style="width: 70px;"></div>
  </nav>

  <!-- Sticky Tabs -->
  <div class="tab-bar card-glass">
    <button
      class="tab-btn"
      [class.active]="activeTab === 'conversations'"
      (click)="activeTab = 'conversations'">
      Conversations
    </button>
    <button
      class="tab-btn"
      [class.active]="activeTab === 'liked'"
      (click)="activeTab = 'liked'">
      Liked Users
    </button>
  </div>

  <!-- Main Content -->
  <div class="main-content-scroll">
    <div class="main-content container">
      <!-- Conversations Tab -->
      <ng-container *ngIf="activeTab === 'conversations'">
        <ng-container *ngIf="previousChats.length > 0; else noChats">
          <div *ngFor="let chat of previousChats; trackBy: trackByChatUserId" class="chat-card card-glass" [class.selected]="chat.selected">
            <div class="chat-content" (click)="goToChat(chat)">
              <div class="avatar-circle">
                {{ chat.originalName[0] | uppercase }}
              </div>
              <div class="chat-info d-flex align-items-center">
                <h6 class="mb-0">{{ chat.originalName }}</h6>
                <span *ngIf="chat.unreadCount > 0" class="unread-badge-red ms-2">{{ chat.unreadCount }}</span>
              </div>
            </div>
            <div class="action-section">
              <input title="check" type="checkbox" [(ngModel)]="chat.selected" (change)="onChatSelectChange()" />
              <button type="button" class="btn btn-neon" (click)="goToChat(chat)">Open</button>
            </div>
          </div>
        </ng-container>
        <ng-template #noChats>
          <div class="no-chat-card card-glass text-center">
            <h5>No previous chats 📭</h5>
            <p>Start a conversation and it will appear here.</p>
          </div>
        </ng-template>
      </ng-container>

      <!-- Liked Users Tab (unchanged) -->
      <ng-container *ngIf="activeTab === 'liked'">
        <ng-container *ngIf="likedUsers.length > 0; else noLiked"> 
          <div *ngFor="let user of likedUsers; trackBy: trackByUserId" class="chat-card card-glass liked-user-card">
            <div class="chat-content" (click)="goToUserProfile(user)">
              <div class="avatar-circle liked-avatar">
                {{ user.name[0] | uppercase }}
              </div>
              <div class="chat-info">
                <h6>{{ user.name }}</h6>
                <!-- <small>{{ user.username }}</small> -->
              </div>
            </div>
            <div class="action-section">
              <button type="button" class="btn btn-neon" (click)="goToChat(user)">
                <i class="bi bi-chat-dots"></i> Chat
              </button>
              <button type="button" class="btn btn-outline-danger" (click)="dislikeUser(user)">
                <i class="bi bi-x-circle"></i> Dislike
              </button>
            </div>
          </div>
        </ng-container>
        <ng-template #noLiked>
          <div class="no-chat-card card-glass text-center">
            <h5>No liked users 💔</h5>
            <p>Like someone and they will appear here.</p>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>

<app-spinner [show]="spinner" [message]="spinMessage" />